export default {}; // no OpenDota-style numeric id map for HoK
